import { Controller } from '@hotwired/stimulus'

// Example controller. Connect with: <div data-controller="hello"></div>
export default class extends Controller {
  connect() {
    this.element.textContent = 'Hello from Stimulus!'
  }
}
